import api from './client';
import { AdminUser, ChangeRoleRequest } from '../types';

export const adminApi = {
  listUsers: () => api.get<AdminUser[]>('/api/admin/users'),
  approve: (id: string) => api.post(`/api/admin/users/${id}/approve`),
  reject: (id: string) => api.post(`/api/admin/users/${id}/reject`),
  changeRole: (id: string, data: ChangeRoleRequest) =>
    api.put(`/api/admin/users/${id}/role`, data),
};
